import { render, staticRenderFns } from "./TeamInsights.vue?vue&type=template&id=8f63b958"
import script from "./TeamInsights.vue?vue&type=script&lang=js"
export * from "./TeamInsights.vue?vue&type=script&lang=js"
import style0 from "./TeamInsightsModern.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports